/**
 * Required to make data from server in useAsyncData serializable; see https://github.com/nuxt/nuxt/issues/21832#issuecomment-1610982355
 */
export default definePayloadPlugin(() => {
  definePayloadReducer("JSONifiable", data => data?.toJSON && JSON.stringify(data.toJSON()));
  definePayloadReviver("JSONifiable", data => JSON.parse(data));
});
